import { ArrowUpRight, Menu, Phone, X } from "lucide-react";
import { BRAND } from "@/data/content";
import { BrandLogo } from "@/components/BrandLogo";

export function SiteHeader({ t, lang, setLang, menuOpen, setMenuOpen }) {
    const closeMenu = () => setMenuOpen(false);
    const renderLinks = (prefix) => t.nav.map((item) => (
        <a
            key={`${prefix}-${item.id}`}
            className="site-nav__link"
            href={item.href}
            onClick={closeMenu}
            data-testid={`reset365-${prefix}-nav-${item.id}-link`}
        >
            {item.label}
        </a>
    ));

    return (
        <header className="site-header">
            <div className="site-header__inner">
                <a href="#accueil" className="site-header__brand" onClick={closeMenu} data-testid="reset365-header-home-link">
                    <BrandLogo location="header" />
                </a>
                <nav className="site-nav" aria-label={lang === "fr" ? "Navigation principale" : "Main navigation"}>
                    {renderLinks("desktop")}
                </nav>
                <div className="site-header__actions">
                    <a href={BRAND.phoneHref} className="header-phone" data-testid="reset365-header-call-link">
                        <Phone size={15} strokeWidth={2.2} aria-hidden="true" />
                        <span>{BRAND.phone}</span>
                    </a>
                    <button className="language-toggle" type="button" onClick={() => setLang(lang === "fr" ? "en" : "fr")} aria-label={t.languageAria} aria-pressed={lang === "en"} data-testid="reset365-language-toggle">
                        {t.languageLabel}
                    </button>
                    <a href="#soumission" className="button button--header" onClick={closeMenu} data-testid="reset365-header-quote-btn">
                        {t.headerCta}
                        <ArrowUpRight size={15} aria-hidden="true" />
                    </a>
                    <a href="#soumission" className="mobile-header-quote" onClick={closeMenu} data-testid="reset365-mobile-header-quote-btn">
                        {lang === "fr" ? "SOUMISSION" : "QUOTE"}
                    </a>
                    <button className="menu-toggle" type="button" onClick={() => setMenuOpen(!menuOpen)} aria-expanded={menuOpen} aria-label={menuOpen ? "Fermer le menu" : "Ouvrir le menu"} data-testid="reset365-menu-toggle">
                        {menuOpen ? <X size={23} aria-hidden="true" /> : <Menu size={23} aria-hidden="true" />}
                    </button>
                </div>
            </div>
            {menuOpen && (
                <div className="site-header__mobile-panel">
                    <nav className="site-nav site-nav--mobile" aria-label="Navigation mobile">
                        {renderLinks("mobile")}
                    </nav>
                    <div className="site-header__mobile-actions">
                        <a href={BRAND.phoneHref} className="mobile-call-link" onClick={closeMenu} data-testid="reset365-mobile-call-link">
                            <Phone size={16} aria-hidden="true" />
                            {t.headerCall} · {BRAND.phone}
                        </a>
                        <a href="#soumission" className="button button--mobile" onClick={closeMenu} data-testid="reset365-mobile-quote-btn">
                            {t.headerCta}
                            <ArrowUpRight size={15} aria-hidden="true" />
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
}
